import React, { useContext } from "react";
import { Box, Typography } from "@material-ui/core";
import { DividerText } from "../../components/DividerText";
import useStyles from "./styles";
import { AutoRegistrationContext } from "../../context/AutoRegistrationProvider";

export const Initial = () => {
  const classes = useStyles();
  const { setStep } = useContext(AutoRegistrationContext);

  return (
    <Box className={classes.registrationContainer}>
      <Typography variant="h5" className={classes.whatDoYouWantToDo}>
        O que você deseja fazer?
      </Typography>
      <Box className={classes.buttonsContainer}>
        <button onClick={() => setStep(5)}>Troca de Notas</button>
        <button onClick={() => setStep(1)}>Agendamentos</button>
      </Box>
      <DividerText>
        <Typography className={classes.dividerText}>ou</Typography>
      </DividerText>
      <Box className={classes.goBack}>
        <Typography variant="h6">
          Já possui uma conta?{" "}
          <a href="/application/Login/index">Ir para a tela de login</a>
        </Typography>
      </Box>
    </Box>
  );
};
